







import { Component, Vue, Prop } from "vue-property-decorator";
import {AnswerType} from "../store/main.interfaces";

const MIN_VALUE = 0;
const BIG_MAX_VALUE = 5000;
const LOW_MAX_VALUE = 100;
@Component
export default class NumberAnswer extends Vue {
  @Prop() defaultValue!: number;
  @Prop() answerType!: AnswerType;
  maxValue: number = LOW_MAX_VALUE;

  @Prop() currentValueUsed!: number;
  get currentValue() {
    return this.currentValueUsed;
  }
  emitNumberUpdate(this: NumberAnswer) {
    this.$emit("numberUpdate", this.currentValue);
  }
  data() {
    return {
      valueScope: [
        (val: number) => {
          if (this.currentValueUsed > this.maxValue) {
            this.currentValueUsed = this.maxValue;
            return "Value is not in the defined scope";
          } else if (this.currentValueUsed < MIN_VALUE) {
            this.currentValueUsed = MIN_VALUE;
            return "Value can't be lower than 0";
          } else return true;
        }
      ]
    };
  }
  created() {
    if (this.answerType === "large_number") {
      this.maxValue = BIG_MAX_VALUE;
    } else {
      this.maxValue = LOW_MAX_VALUE;
    }
  }
}
